import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LTileLayer = _resolveComponent("LTileLayer")!
  const _component_LIcon = _resolveComponent("LIcon")!
  const _component_LMarker = _resolveComponent("LMarker")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createBlock(_component_LMap, {
    ref: "map",
    class: "map-standalone-map",
    center: _ctx.center,
    zoom: _ctx.zoom,
    minZoom: 2,
    maxZoom: _ctx.tileLayerOptions.maxZoom,
    options: _ctx.mapOptions,
    crossOrigin: true,
    onReady: _ctx.onReady,
    onMoveend: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('moveend'))),
    onZoomend: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('zoomend'))),
    onTouchstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
    onTouchmove: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
    onTouchend: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
    onTouchcancel: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_LTileLayer, {
        key: _ctx.tileurl,
        url: _ctx.tileurl,
        attribution: _ctx.attribution,
        noWrap: true,
        options: _ctx.tileLayerOptions
      }, null, 8, ["url", "attribution", "options"])),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pins ?? [], (pin, index) => {
        return (_openBlock(), _createBlock(_component_LMarker, {
          key: index,
          "lat-lng": pin,
          options: _ctx.markerOptions
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LIcon, {
              "icon-size": [24, 24],
              "icon-anchor": [12, 12],
              className: 'map-standalone-icon'
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "pin" }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["lat-lng", "options"]))
      }), 128)),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["center", "zoom", "maxZoom", "options", "onReady"]))
}